<template>
    <div class="card mb-3">
        <div class="card-body">
            <a data-toggle="modal" data-target="#new-request" class="btn btn-success text-white ml-2">درخواست بازگشت وجه</a>
            <router-link :to="{name: 'organization.wallet.cashBack'}" class="btn btn-primary">لیست درخواست های بازگشت وجه</router-link>
            <hr>
            <Loading v-if="showLoading" />
            <div class="alert alert-primary">
                <p class="mb-0">میزان موجودی کیف پول : <b>{{ deposit }} ریال</b></p>
            </div>
            <h5 class="mb-3">افزایش موجودی</h5>
            <form class="row" v-if="!setAmount" v-on:submit.prevent="sendRequest">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>مبلغ شارژ (ریال)</label>
                        <input type="tel" class="form-control ltr-input" v-model="amount" @keyup="e => changeCustomDepositValue(e)">
                    </div>
                </div>
                <div class="col-md-12">
                    <button class="btn btn-success" :disabled="!amount || amount.toString().replace(/,/g,'') < 10000">پرداخت و افزایش اعتبار</button>
                </div>
            </form>
            <div class="row justify-content-center" v-else-if="setAmount && !paymentType">
                <div class="col-md-12 text-center">
                    <p>درخواست افزایش موجودی به مبلغ : <b>{{ amount }} ریال</b></p>
                </div>
                <button class="btn ripple btn-outline-info btn-rounded ml-2" @click="paymentWithIPG" v-if="amount.toString().replace(/,/g,'') <= 500000000">پرداخت از طریق درگاه پرداخت</button>
                <button class="btn ripple btn-outline-primary btn-rounded ml-2" @click="cashPayment">پرداخت از طریق فیش بانکی</button>
                <button class="btn ripple btn-outline-danger btn-rounded" @click="amount = '';setAmount = false">اصلاح مبلغ</button>
            </div>
            <div class="row justify-content-center" v-if="paymentType && paymentType == 'ipg'">
                <img src="/assets/img/loading-ipg.gif" width="170px">
                <div class="col-12">
                    <p class="text-center">در حال انتقال به درگاه پرداخت ...</p>
                </div>
            </div>
            <div class="row justify-content-center" v-if="paymentType && paymentType == 'cash'">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>شناسه پرداخت / شماره پیگیری</label>
                        <input type="tel" class="form-control ltr-input" v-model="paymentIdentifier">
                    </div>
                    <div class="form-group">
                        <label>شماره ارجاع / شماره درخواست</label>
                        <input type="tel" class="form-control ltr-input" v-model="rrn">
                    </div>
                    <div class="form-group">
                        <label>تصویر فیش واریزی</label>
                        <div class="input-group file-browser">
                            <input id="file-input" type="text" class="form-control border-left-0 browse-file" placeholder="انتخاب کنید" readonly="">
                            <label class="input-group-btn">
                                <span class="btn btn-primary">
                                    انتخاب <input type="file" style="display: none;" accept="image/jpeg" @change="setFile">
                                </span>
                            </label>
                        </div>
                    </div>
                    <button class="btn btn-success btn-block" @click="submitPayment">ثبت اطلاعات</button>
                </div>
            </div>
            <div class="modal effect-scale" id="new-request" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content modal-content-demo">
                        <div class="modal-header">
                            <h6 class="modal-title">درخواست بازگشت وجه</h6>
                            <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <Loading v-if="showLoading" />
                            <div class="form-group">
                                <label>مبلغ</label>
                                <input type="tel" class="form-control ltr-input" v-model="cashBackAmount" @keyup="numberFormat">
                            </div>
                            <button class="btn btn-success" data-dismiss="modal" @click="submitRequest">ثبت درخواست</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Wallet',
    data(){
        return {
            showLoading: false,
            amount: '',
            setAmount: false,
            paymentType: '',
            paymentIdentifier: '',
            deposit: 0,
            requestId: 0,
            cashBackAmount: '',
            rrn: '',
            file: ''
        }
    },
    methods: {
        getData(){
            if(this.$store.state.userData.isOrganization){
                this.$api.get('Organizations/Wallet/Balance').then(({data}) => {
                    if(data.status)
                        this.deposit = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(data.result);
                });
            }
        },
        numberFormat(){
            let value = this.cashBackAmount.toString().replace(/,/g,'');
            if(value > parseInt(this.deposit.toString().replace(/,/g,'')))
                value = parseInt(this.deposit.toString().replace(/,/g,''));
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.cashBackAmount = value;
        },
        changeCustomDepositValue(e){
            let value = this.amount ? this.amount.replace(/,/gi,'') : 0;
            let numbers = /^[0-9]*$/;
            if(!numbers.test(e.target.value)){
                e.preventDefault();
            }
            if(value > 10000000000)
                value = 10000000000;
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.amount = value;
        },
        paymentWithIPG(){
            this.showLoading = true;
            this.paymentType = 'ipg';
            const postedData = {
                requestId: this.requestId
            };
            this.$api.post('Organizations/Wallet/IPGPayment',postedData).then(({data}) => {
                if(data.status)
                    window.location.href = data.result;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        cashPayment(){
            this.paymentType = 'cash';
        },
        sendRequest(){
            this.showLoading = true;
            const postedData = {
                chargeAmount: parseInt(this.amount.toString().replace(/,/g,''))
            };
            this.$api.post('Organizations/Wallet/Charge',postedData).then(({data}) => {
                if(data.status){
                    this.setAmount = true;
                    this.requestId = data.result.requestId;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        submitPayment(){
            this.showLoading = true;
            const postedData = {
                requestId: this.requestId,
                paymentIdentifier: this.paymentIdentifier,
                rrn: this.rrn,
                base64Receipt: this.file
            };
            this.$api.post('Organizations/Bonus/Request/Payment',postedData).then(({data}) => {
                if(data.status)
                    this.$router.push({name: 'organization.transactions'});
            }).finally(() => {
                this.showLoading = false;
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            document.getElementById('file-input').setAttribute('placeholder',file.name);
        },
        submitRequest(){
            this.showLoading = true;
            const postedData = {
                amount: parseInt(this.cashBackAmount.toString().replace(/,/g,'')),
            };
            this.$api.post('Organizations/Wallet/CashBack/Request',postedData).then(({data}) => {
                if(data.status){
                    $('#new-request').modal('toggle');
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'درخواست بازگشت وجه با موفقیت ثبت شد'
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
        let amount = localStorage.getItem('amount');
        if(amount)
            this.amount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(amount);
        localStorage.removeItem('amount');
    }
}
</script>